import * as React from "react";
import "./styles.scss";
import { withTranslation } from "react-i18next";
import Laststep from "../../components/ChekoutPage/Laststep";
import RegShell from "./RegShell";

function LastReg() {
  return (
    <RegShell step={1}>
      <Laststep />
    </RegShell>
  );
}
export default withTranslation()(LastReg);
